import { render, staticRenderFns } from "./WsUpload.vue?vue&type=template&id=242eade1"
import script from "./WsUpload.vue?vue&type=script&lang=js"
export * from "./WsUpload.vue?vue&type=script&lang=js"
import style0 from "./WsUpload.vue?vue&type=style&index=0&id=242eade1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports